/* eslint-disable */

export default (context) => {
    if (!context) context = document;

    let _last_sent_decimal = '';
    const   roman   = ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'],
            decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];

    init();

    function init() {
        const widget = {
            container:   context.querySelector('#roman-numerals-widget'),
            decimal:     context.querySelector('#decimal-input'),
            decimal_btn: context.querySelector('#decimal-convert'),
            roman:       context.querySelector('#roman-input'),
            roman_btn:   context.querySelector('#roman-convert')
        };

        if (!!widget.container) {

            widget.decimal.addEventListener('keypress', function (e) {
                if (e.which === 13) {
                    _updateRoman(widget);
                    e.preventDefault();
                }
            });

            widget.roman.addEventListener('keypress', function (e) {
                if (e.which === 13) {
                    _updateDecimal(widget);
                    e.preventDefault();
                }
            });

            //BUGFIX: when empty, span style overline comes back
            widget.roman.addEventListener('keyup', function () {
                if (widget.roman.innerText.length === 0) {
                    const n_input = document.createElement('span'),
                        parent  = widget.roman.parentNode;

                    n_input.id = 'roman-input';
                    n_input.setAttribute('contenteditable', 'true');
                    n_input.style = 'margin-right: 4px;';

                    widget.roman.remove();
                    parent.insertBefore(n_input, parent.children[1]);

                    init();
                }
            });

            widget.decimal_btn.addEventListener('click', function () { _updateRoman(widget); });

            widget.roman_btn.addEventListener('click', function () { _updateDecimal(widget); });

        }
    }

    /**
     * Get roman char
     * @param value
     * @returns {{numThousands: number, romanNumeral: string}}
     * @private
     */
    function _getRoman(value) {
        let romanNumeral = '';
        let numThousands = 0;
        for (let i = 0; i < roman.length; i++) {
            if (value === 0) break;
            while (value >= decimal[i]) {
                value -= decimal[i];
                romanNumeral += roman[i];
                if (roman[i] === 'M') numThousands++;
            }
        }
        return { numThousands: numThousands, romanNumeral: romanNumeral };
    }

    /**
     * Convert to roman numeral
     * @param value
     * @returns {string}
     * @private
     */
    function _decimalToRoman(value) {
        if (value <= 0 || value > 3888888) return ''; // Ok partir de 3,888,888 já chega..

        let romanNumeral = '',
            romanO       = _getRoman(value);

        // >4000
        if (romanO.numThousands >= 4) {
            let thousandString = '';

            for (let j = 0; j < romanO.numThousands; j++) thousandString += 'M';

            let thousandsO = _getRoman(romanO.numThousands),
                thBase     = '<span class="thousands">' + thousandsO.romanNumeral + '</span>';

            romanNumeral = romanO.romanNumeral.replace(thousandString, thBase);

        } else {
            romanNumeral = romanO.romanNumeral;
        }

        return romanNumeral;
    }

    /**
     * Convert to decimal
     * @param str
     * @returns {*}
     * @private
     */
    function _romanToDecimal(str) {
        let thousands     = 0,
            has_thousands = str.indexOf('<span class="thousands">') !== -1;

        //parse thousands recursively
        if (has_thousands) {
            let range = document.createRange();
            range.selectNode(document.body); // required in Safari
            let fragment = range.createContextualFragment(str);
            let firstNode = fragment.firstChild;
            thousands = _romanToDecimal(firstNode.innerText.toUpperCase()) * 1000;
            firstNode.remove();
            str = fragment.textContent;
        }

        const   roman   = ['M', 'D', 'C', 'L', 'X', 'V', 'I'],
                decimal = [1000, 500, 100, 50, 10, 5, 1];
        let     intDec  = 0,
                intArap = 0,
                tempRim = 0;

        str = str.toUpperCase();

        for (let i = 0, imax = str.length; i < imax; i++) {
            for (let j = 0, jmax = roman.length; j < jmax; j++) {
                if (roman[j] == str.charAt(i)) {
                    intArap = decimal[j];
                    break;
                }
                intArap = 0;
            }
            if (intArap === 0) { return ''; }
            if (tempRim < intArap) {
                tempRim *= -1
            }
            intDec += tempRim;
            tempRim = intArap;
        }
        intDec += tempRim;

        return thousands + intDec;
    };

    function _updateRoman(widget) {
        if (widget.decimal.value !== '') {
            widget.decimal.value = Math.floor(widget.decimal.value);
            widget.roman.innerHTML = _decimalToRoman(widget.decimal.value);
            _sendHit(widget);
            _insertLink(widget);
        }
    };

    function _updateDecimal(widget) {
        if (widget.roman.innerHTML !== '') {
            widget.decimal.value = _romanToDecimal(widget.roman.innerHTML);
            _updateRoman(widget); //autocorrect
            _sendHit(widget);
            _insertLink(widget);
        }
    };

    function _insertLink(widget) {
        let old = context.querySelector('#numerals-link');
        if (old) old.remove();

        if (widget.decimal.value > 0 && widget.decimal.value < 4000) {

            const link = document.createElement('div');
            link.id = 'numerals-link';

            link.innerHTML = '<a href="/numeros-romanos/' + widget.roman.innerText.toLowerCase() + '/">'
                + widget.roman.innerText
                + '</a> = <a href="/numeros-romanos/' + widget.decimal.value + '/">'
                + widget.decimal.value
                + '</a>';

            widget.container.appendChild(link)
        }
    };

    function _sendHit(widget) {
        const decimal = parseInt(widget.decimal.value);

        if (decimal !== '' && decimal < 4000 && decimal > 0 && decimal !== _last_sent_decimal) {
            _last_sent_decimal = decimal;

            fetch('/roman_hit.php', {
                method: 'POST',
                body: JSON.stringify({ 'decimal': decimal })
            });
        }
    };

}